/*
向local中存储数据的工具模块
1. 向外暴露一个函数(功能)
   只有一个功能需要暴露
2. 向外暴露一个对象(包含多个功能)
   有多个功能需要暴露
 */
import Cookie from 'js-cookie'
import Encrypt from './encrypt'
const TODOS_KEY = 'cfvn-user';
const RANGELIST = 'cfvn-rangeList';
const CITY = 'lang';
const TIMEDATA = 'timeData';
const RECHARGEDATA = 'rechargeData';
export default {
    readUser () {
        return JSON.parse(Encrypt.get(Cookie.get(TODOS_KEY)) || '{}');
    },
    saveUser (user) {
        const expiresTime = 60 * 1000 * 60 * 24 * 1;//过期时间
        const millisecond = new Date().getTime();
        const date = new Date(millisecond + expiresTime);
        Cookie.set(TODOS_KEY,Encrypt.set(JSON.stringify(user)),{expires: date, path: '/'});
    },
    readRange() {
        return JSON.parse(localStorage.getItem(RANGELIST) || '{}')
    },
    saveRange(range) {
        localStorage.setItem(RANGELIST, JSON.stringify(range))
    },
    readLang() {
        return localStorage.getItem(CITY) || process.env.VUE_APP_LOCAALE;
    },
    saveLang(lang) {
        localStorage.setItem(CITY, lang)
    },
    readTimeData() {
        return JSON.parse(localStorage.getItem(TIMEDATA));
    },
    saveTimeData(timeData) {
        localStorage.setItem(TIMEDATA, JSON.stringify(timeData))
    },
    readRechargeData() {
        return JSON.parse(Encrypt.get(localStorage.getItem(RECHARGEDATA)));
    },
    saveRechargeData(rechargeData) {
        localStorage.setItem(RECHARGEDATA, Encrypt.set(JSON.stringify(rechargeData)))
    },
}

